import { _post } from 'frontcore/utils/communications/apiClient'
import {
  PasswordUpdateAPIClient,
  PasswordUpdateAPIClientPayload,
} from 'frontcore/domain/authorization/model/usePasswordUpdate.d'

const url = 'update-password/'

export default class PasswordUpdateAPIClientHTTP implements PasswordUpdateAPIClient {

  async update (payload: PasswordUpdateAPIClientPayload): Promise<void> {
    const body = {
      new_password: payload.newPassword,
      old_password: payload.oldPassword,
      user: payload.user,
      token: payload.token,
    }
    await _post(url, body)
  }
}
